import { consola } from 'consola'
import { useTabsSync, TabSyncEventType } from '@shared/lib'

// Logger
const logger = consola.withTag('tabs-sync-logout-plugin')

/**
 * Плагин для синхронизации разлогина между вкладками
 * 
 * ✅ Автоматически разлогинивает во всех вкладках одновременно
 * ✅ Предотвращает рассинхронизацию состояния авторизации
 * ✅ Немедленная реакция на разлогин в любой вкладке
 */
export default defineNuxtPlugin((_nuxtApp) => {
  if (!process.client) return

  logger.info('🔌 Инициализация плагина синхронизации разлогина')

  const tabsSync = useTabsSync()

  // Слушаем событие разлогина из других вкладок
  tabsSync.on(TabSyncEventType.USER_LOGGED_OUT, async (event) => {
    logger.warn('🚪 Получено событие разлогина из другой вкладки', {
      fromTab: event.tabId,
      reason: event.data.reason,
      timestamp: new Date(event.data.timestamp).toISOString(),
    })

    // Импортируем зависимые модули динамически
    const { useSessionManager } = await import('~/entities/auth/model')
    const { useLogoutHandler } = await import('~/features/auth/model')

    const sessionManager = useSessionManager()
    const logoutHandler = useLogoutHandler()

    // Проверяем, есть ли еще активная сессия в этой вкладке
    if (!sessionManager.hasActiveSession.value) {
      logger.info('✅ Сессия уже очищена в этой вкладке, пропускаем')
      return
    }

    // Выполняем разлогин в этой вкладке (тихий, без уведомления других вкладок)
    logger.info('🔄 Выполняем разлогин в этой вкладке')
    
    // Очищаем данные локально
    sessionManager.clearSession()
    logoutHandler.handleSuccessfulLogout()
    
    // Редиректим на главную
    if (window.location.pathname !== '/') {
      logger.info('🔄 Редирект на главную страницу')
      await navigateTo('/', { replace: true })
    }
  })

  // Слушаем событие истечения сессии
  tabsSync.on(TabSyncEventType.SESSION_EXPIRED, async (event) => {
    logger.warn('⏰ Сессия истекла (уведомление из другой вкладки)', {
      fromTab: event.tabId,
    })

    const { useSessionManager } = await import('~/entities/auth')
    const sessionManager = useSessionManager()

    // Очищаем сессию если она еще активна
    if (sessionManager.hasActiveSession.value) {
      logger.info('🔄 Очищаем истекшую сессию')
      sessionManager.clearSession()
      
      if (window.location.pathname !== '/') {
        await navigateTo('/', { replace: true })
      }
    }
  })

  logger.success('✅ Плагин синхронизации разлогина инициализирован')
})

